import { vplSiteStore } from '../../store/vplstore';
import { showCatalogPreloader } from '../preloader/preloader';

import { closeHeaderCatalog, clearSearch, resetBurger } from '../../tools/functions';
import { hit as analyticsHit } from '../analytics/analytics';

function updateMetaTag(name, content) {
    const value = typeof content === 'string' ? content.trim() : '';
    let tag = document.head.querySelector(`meta[name="${name}"]`);

    if (!value) {
        if (tag) {
            tag.remove();
        }
        return;
    }

    if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
    }

    tag.setAttribute('content', value);
}

function updateCanonicalTag(href) {
    const links = Array.from(document.querySelectorAll('link[rel]')).filter((link) =>
        link.rel.toLowerCase().split(/\s+/).includes('canonical')
    );
    const value = typeof href === 'string' ? href.trim() : '';
    links.slice(1).forEach((link) => link.remove());
    if (!value) {
        if (links[0]) links[0].remove();
        return;
    }
    const link = links[0] || document.createElement('link');
    link.rel = 'canonical';
    link.setAttribute('href', value);
    document.head.appendChild(link);
}

export function VplRouter(route, event = false, nopushstate = false, doScroll = true, callback = false){
    let hostname, dropdown, relative = false;

    if (event && event.target.classList.contains('js-dropdown-link')
    || event && event.target.classList.contains('js-editable')) {
        event.preventDefault();
        event.stopPropagation();
        dropdown = true;
    }

    if (route.indexOf("//") > -1) {
        hostname = route.split('/')[2];
    } else {
        hostname = route.split('/')[0];
        if(route[0] === '/') relative = true;
    }
    hostname = hostname.split(':')[0];
    hostname = hostname.split('?')[0];

    let targetBlank = false;
    if(event && event.target.getAttribute('target') === '_blank')
        targetBlank = true;

    let pathname = route.split('?')[0];

    const store = vplSiteStore();

    if(store.edit !== true && !targetBlank && (relative || hostname===window.location.hostname) && !dropdown && (!window.nospa || !window.nospa.includes(pathname))){
        if(event)
            event.preventDefault();

        //массив для якорного перехода
        let arAncorRoute = route.split('#');
        route = arAncorRoute[0];
        let arRoute = route.split('?');
        let params = 'get_json=Y';

        if(arRoute[1]){
            params += '&' + arRoute[1];
        }

        if(hostname && hostname===window.location.hostname && arRoute[0].indexOf(hostname) >= 0){
            arRoute[0] = arRoute[0].split(hostname);
            arRoute[0] = arRoute[0][1];
            if(!arRoute[0]) arRoute[0] = '/';
        }

        showCatalogPreloader();

        // SAIT-149: после серверного редиректа (301 с истёкшей акции) в историю пишется конечный адрес без get_json
        let redirectedUrl = null;
        const historyUrl = () => {
            if (redirectedUrl) {
                try {
                    const url = new URL(redirectedUrl);
                    url.searchParams.delete('get_json');
                    return url.toString();
                } catch (e) {}
            }
            return (relative ? window.location.origin + route : route);
        };

        fetch(arRoute[0] + '?' + params)
            .then((response) => {
                redirectedUrl = response.redirected ? response.url : null;
                return response.text();
            })
            .then((text) => {

                try {
                    const data = JSON.parse(text);

                    //страница 404
                    if(data.RESPONSE_CODE == 404){
                        $('body').addClass('not-found');
                        $('header').hide();
                        $('#footer').hide();
                        //$('.wrapper').css('padding-top', '0');
                    }else{
                        $('body').removeClass('not-found');
                        //$('.wrapper').css('padding-top', '');
                        $('header').show();
                        $('#footer').show();
                    }

                    $('.js-header-basket-link').removeClass('is-open');
                    $('.js-header-basket-link-dropdown').removeClass('is-show');
                    $('.js-header-action-item-link').removeClass('is-open');
                    $('.js-header-action-item-link-dropdown').removeClass('is-show');
                    $('.js-catalog-dropdown').removeClass('is-open');
                    $('.js-catalog').removeClass('is-active');
                    $('body').removeClass('dropdown-open');
                    //$('.js-header-search-overlay')
                    $('.js-search-input').val('');
                    closeHeaderCatalog();
                    clearSearch();

                    resetBurger();
                    $('body').removeClass('dropdown-open');

                    $('.js-overlay').removeClass('is-show');
                    $('.js-header-search-mob').removeClass('is-show');
                    $('.js-fixed-search').removeClass('is-active');
                    $('.js-mob-contacts-btn').removeClass('is-active');
                    $('.js-mob-contacts').removeClass('is-open');

                    store.menu = data.menu;
                    store.compare = data.compare;
                    store.favorite = data.favorite;
                    store.form = data.form;
                    store.rekey = data.rekey;
                    store.templateData = (data.templateData ? data.templateData : []);
                    store.struct = (data.struct ? data.struct : []);
                    store.basket = data.basket;
                    store.title = data.title;
                    store.h1 = data.h1;
                    store.SITE_TEMPLATE_PATH = data.SITE_TEMPLATE_PATH;
                    store.YA_CLIENT_KEY = data.YA_CLIENT_KEY;
                    store.IS_DEALER = data.IS_DEALER;
                    store.IS_AUTHORIZED = data.IS_AUTHORIZED
                    store.type = 'json';
                    store.url = data.url;
                    store.edit = data.edit;
                    store.fastview = {};
                    store.RESPONSE_CODE = data.RESPONSE_CODE;
                    store.REQUEST_URL = arRoute[0];
                    document.title = data.browser_title || data.title || data.h1 || '';
                    updateMetaTag('description', data.meta_description);
                    updateMetaTag('keywords', data.meta_keywords);
                    updateCanonicalTag(data.canonical);
                    if(!nopushstate){
                        const currentHistoryUrl = window.location.href;
                        const targetHistoryUrl = historyUrl();

                        window.history.replaceState(
                            {
                                url: currentHistoryUrl,
                                scrollTop: window.scrollY
                            },
                            document.title,
                            currentHistoryUrl
                        );

                        window.history.pushState(
                            {
                                url: targetHistoryUrl,
                                scrollTop: (doScroll ? 0 : window.scrollY)
                            },
                            (data.title ? data.title : data.h1),
                            targetHistoryUrl
                        );
                    }

                    //якорь
                    store.ancor = arAncorRoute[1];
                    if(!store.ancor && doScroll){
                        //скролл к началу страницы
                        $([document.documentElement, document.body]).animate({
                            scrollTop: 0/*$("#elementtoScrollToID").offset().top*/
                        }, 500);
                    }

                } catch(err) {
                    store.textContent = text;
                    store.type = 'text';
                    if(!nopushstate){
                        const currentHistoryUrl = window.location.href;
                        const targetHistoryUrl = historyUrl();

                        window.history.replaceState(
                            {
                                url: currentHistoryUrl,
                                scrollTop: window.scrollY
                            },
                            document.title,
                            currentHistoryUrl
                        );

                        window.history.pushState(
                            {
                                url: targetHistoryUrl,
                                scrollTop: (doScroll ? 0 : window.scrollY)
                            },
                            document.title,
                            targetHistoryUrl
                        );
                    }
                }

                // Метрика: просмотр страницы при SPA-переходе (pushState она не
                // видит); при возврате «назад» адрес уже сменил браузер — модуль
                // сам не шлёт повтор, если адрес не менялся (перезагрузка данных
                // той же страницы, например после сохранения профиля в ЛК)
                analyticsHit(window.location.href, document.title);

                if(callback !== false){
                    callback();
                }
        });

    }

}